module.exports = __webpack_public_path__ + "img/103.71f3a2b8.jpg";